import {Component, Input, OnInit, OnChanges, Output, EventEmitter, ChangeDetectorRef, SimpleChanges} from "@angular/core";
import {LabelService} from "../service/label.service";
import {toPromise} from "../utils";
import {Label} from "../service/interface";
import {ErrorHandler} from "../error-handler/error-handler";
import {Subject} from "rxjs/Subject";

export interface LabelState {
    iconsShow: boolean;
    label: Label;
    show: boolean;
}

@Component({
    selector: "hbr-filter-label",
    template: `<div class="filterLabelPanel" [hidden]="!openFilterLabelPanel">
    <a class="filterClose" (click)="closeFilter()">&times;</a>
    <label class="filterLabelHeader">{{'REPOSITORY.FILTER_BY_LABEL' | translate}}</label>
    <div><input class="filterInput" type="text" placeholder="Filter labels" [(ngModel)]= "filterLabelName" (keyup)="handleInputFilter()"></div>
    <div [hidden]='labelLists.length' style="padding-left:10px;">{{'LABEL.NO_LABELS' | translate }}</div>

    <div [hidden]='!labelLists.length' style='max-height:300px;overflow-y: auto;'>
        <button type="button" class="labelBtn" *ngFor='let label of labelLists' [hidden]='!label.show' (click)="selectLabel(label)">
            <clr-icon shape="check" class='pull-left' [hidden]='!label.iconsShow'></clr-icon>
            <div class='labelDiv'><hbr-label-piece [label]="label.label"  [labelWidth]="118"></hbr-label-piece></div>
        </button>
    </div>
</div>`,
    styles: [`.filterLabelPanel{display:flex;position:absolute;left:135px;flex-direction:column;background:#fff;padding:.5rem 0;border:1px solid #ccc;box-shadow:0 1px .125rem rgba(115,115,115,.25);min-width:5rem;max-width:15rem;border-radius:.125rem;z-index:100}.filterLabelPanel .filterInput{margin-left:.5rem;margin-right:.5rem}.filterLabelHeader{font-size:.5rem;font-weight:600;letter-spacing:normal;padding:0 .5rem;line-height:.75rem;margin:0;color:#313131}.filterLabelPanel .form-group input{position:relative;margin-left:.5rem;margin-right:.5rem}.filterClose{position:absolute;right:8px;top:5px;cursor:pointer;font-size:20px}.pull-left{display:inline-block;float:left}.pull-right{display:inline-block;float:right}.btn-link{display:inline-flex;width:15px;min-width:15px;color:#000;vertical-align:super}.signpost-item,.trigger-item{display:inline}.signpost-content-body .label{margin:.3rem}.labelDiv{position:absolute;left:28px;top:5px}.datagrid-action-bar{z-index:10}.trigger-item hbr-label-piece{display:flex!important;margin:6px 0}:host>>>.signpost-content{min-width:4rem}:host>>>.signpost-content-body{padding:0 .4rem}:host>>>.signpost-content-header{display:none}.filterLabelPiece{position:absolute;top:4px;z-index:1}.dropdown .dropdown-toggle.btn{margin:.25rem .5rem .25rem 0}.labelBtn{position:relative;overflow:hidden;font-size:.58333rem;letter-spacing:normal;font-weight:400;background:0 0;border:0;color:#565656;cursor:pointer;display:block;margin:0;width:100%;height:30px;text-transform:none}.labelBtn:hover{background-color:#eee}.labelBtn:focus{outline:0}.labelDiv label{margin:0}`]
})
export class FilterLabelComponent implements OnInit, OnChanges {

    openFilterLabelPanel: boolean;
    labelLists: LabelState[] = [];
    filterLabelName = '';
    labelNameFilter: Subject<string> = new Subject<string> ();
    @Input() isOpen: boolean;
    @Input() projectId: number;
    @Input() selectedLabelInfo: Label[];
    @Output() selectedLabels = new EventEmitter<LabelState[]>();
    @Output() closePanelEvent = new EventEmitter();

    constructor(private labelService: LabelService,
                private ref: ChangeDetectorRef,
                private errorHandler: ErrorHandler) {}

    ngOnInit(): void {
        Promise.all([this.getGLabels(), this.getPLabels()]).then(() => {
            this.selectedLabelInfo.forEach(info => {
                if (this.labelLists.length) {
                    let lab = this.labelLists.find(data => data.label.id === info.id);
                    if (lab) {this.selectOper(lab); }
                }
            });
        });

        this.labelNameFilter
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe((name: string) => {
                if (this.filterLabelName.length) {

                    this.labelLists.forEach(data => {
                        if (data.label.name.indexOf(this.filterLabelName) !== -1) {
                            data.show = true;
                        } else {
                            data.show = false;
                        }
                    });
                    setTimeout(() => {
                        setInterval(() => this.ref.markForCheck(), 200);
                    }, 1000);
                }
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['isOpen']) {this.openFilterLabelPanel = changes['isOpen'].currentValue; }
    }

    getGLabels() {
        return toPromise<Label[]>(this.labelService.getGLabels()).then((res: Label[]) => {
            if (res.length) {
                res.forEach(data => {
                    this.labelLists.push({'iconsShow': false, 'label': data, 'show': true});
                });
            }
        }).catch(error => {
            this.errorHandler.error(error);
        });
    }

    getPLabels() {
        if (this.projectId && this.projectId > 0) {
            return toPromise<Label[]>(this.labelService.getPLabels(this.projectId)).then((res1: Label[]) => {
                if (res1.length) {
                    res1.forEach(data => {
                        this.labelLists.push({'iconsShow': false, 'label': data, 'show': true});
                    });
                }
            }).catch(error => {
                this.errorHandler.error(error);
            });
        }
    }

    handleInputFilter(): void {
        if (this.filterLabelName.length) {
            this.labelNameFilter.next(this.filterLabelName);
        }else {
            this.labelLists.every(data => data.show = true);
        }
    }

    selectLabel(labelInfo: LabelState): void {
        if (labelInfo) {
            let isClick = true;
            if (!labelInfo.iconsShow) {
                this.selectOper(labelInfo, isClick);
            } else {
                this.unSelectOper(labelInfo, isClick);
            }
        }
    }

    selectOper(labelInfo: LabelState, isClick?: boolean): void {
        // set the selected label in front
        this.labelLists.splice(this.labelLists.indexOf(labelInfo), 1);
        this.labelLists.some((data, i) => {
            if (!data.iconsShow) {
                this.labelLists.splice(i, 0, labelInfo);
                return true;
            }
        });
        // when is the last one
        if (this.labelLists.every(data => data.iconsShow === true)) {
            this.labelLists.push(labelInfo);
        }

        labelInfo.iconsShow = true;
        if (isClick) {
            this.selectedLabels.emit(this.labelLists);
        }

    }

    unSelectOper(labelInfo: LabelState, isClick?: boolean): void {
        this.sortOperation(this.labelLists, labelInfo);

        labelInfo.iconsShow = false;
        if (isClick) {
            this.selectedLabels.emit(this.labelLists);
        }
    }

    // insert the unselected label to groups with the same icons
    sortOperation(labelList: LabelState[], labelInfo: LabelState): void {
        labelList.some((data, i) => {
            if (!data.iconsShow) {
                if (data.label.scope === labelInfo.label.scope) {
                    labelList.splice(i, 0, labelInfo);
                    labelList.splice(labelList.indexOf(labelInfo, 0), 1);
                    return true;
                }
                if (data.label.scope !== labelInfo.label.scope && i === labelList.length - 1) {
                    labelList.push(labelInfo);
                    labelList.splice(labelList.indexOf(labelInfo), 1);
                    return true;
                }
            }
            if (data.iconsShow && i === labelList.length - 1) {
                labelList.push(labelInfo);
                labelList.splice(labelList.indexOf(labelInfo), 1);
                return true;
            }
        });
    }

    closeFilter(): void {
        this.closePanelEvent.emit();
    }
}
